export default __webpack_public_path__ + "static/media/head01_th_pc@2x.c20d5c58.png";